module.exports = __webpack_public_path__ + "static/logo_alt-9bc192daa6d1d0524aeb513bc30fd42a.png";